/* eslint-disable import/prefer-default-export */
import { getUsableCapacityInitialValue } from '../utils/capacityFallback';
import { buildCustomOperatorFieldDefaults } from '../utils/customOperatorFieldDefaults';

export const getDefaultFormValues = (
  t,
  itemData,
  columnMappings,
  globalState,
  previousItemFormValues,
  fillingStatusFromValue,
  customOperatorFields = [],
) => {
  const getCsv = (key) => columnMappings?.[key]?.mapping?.csvName;
  const getUnit = (key, fallback = '') => (columnMappings?.[key]?.mapping?.unit || fallback);

  const fillingCsv = getCsv('filling');
  const fillingStatus = fillingCsv ? fillingStatusFromValue(itemData[fillingCsv]) : 'full';
  const isEmpty = fillingStatus === 'empty';

  const liquidVolumeCsv = getCsv('liquidVolume');
  const emptyHeightCsv = getCsv('emptyHeight');
  const liquidHeightCsv = getCsv('liquidHeight');

  let measurementType = '';
  if (liquidVolumeCsv && itemData[liquidVolumeCsv] !== '') {
    measurementType = 'liquidVolume';
  } else if (emptyHeightCsv && itemData[emptyHeightCsv] !== '') {
    measurementType = 'emptyHeight';
  } else if (liquidHeightCsv) {
    measurementType = 'liquidHeight';
  }

  const totalCapacityCsv = getCsv('totalCapacity');
  const usableCapacityCsv = getCsv('usableCapacity');
  const totalCapacityUnit = getUnit('totalCapacity', 'L');
  const usableCapacityUnit = getUnit('usableCapacity', 'L');
  const heightUnderBungCsv = getCsv('heightUnderBung');
  const internalDiameterDownCsv = getCsv('internalDiameterDown');
  const internalDiameterUpCsv = getCsv('internalDiameterUp');

  return {
    totalCapacity: {
      value: totalCapacityCsv ? (itemData[totalCapacityCsv] || '') : '',
      unit: totalCapacityUnit,
    },
    // Left out when not mapped, so the form does not show it.
    ...(usableCapacityCsv && {
      usableCapacity: {
        value: getUsableCapacityInitialValue({
          itemData,
          fillingStatus,
          usableCapacityCsv,
          totalCapacityCsv,
          usableCapacityUnit,
          totalCapacityUnit,
        }),
        unit: usableCapacityUnit,
      },
    }),
    diameterBond: {
      value: heightUnderBungCsv ? (itemData[heightUnderBungCsv] || '') : '',
      unit: getUnit('heightUnderBung', 'cm'),
    },
    diameterDown: {
      value: internalDiameterDownCsv ? (itemData[internalDiameterDownCsv] || '') : '',
      unit: getUnit('internalDiameterDown', 'cm'),
    },
    diameterUp: {
      value: internalDiameterUpCsv ? (itemData[internalDiameterUpCsv] || '') : '',
      unit: getUnit('internalDiameterUp', 'cm'),
    },
    liquidHeight: {
      value: liquidHeightCsv ? (itemData[liquidHeightCsv] || '') : '',
      unit: getUnit('heightUnderBung', 'cm'),
    },
    emptyHeight: {
      value: emptyHeightCsv ? (itemData[emptyHeightCsv] || '') : '',
      unit: getUnit('heightUnderBung', 'cm'),
    },
    liquidVolume: {
      value: liquidVolumeCsv ? (itemData[liquidVolumeCsv] || '') : '',
      unit: getUnit('liquidVolume', 'L'),
    },
    measurementType,
    tav: (!isEmpty && previousItemFormValues?.tav)
            || {
              value: (getCsv('tav') ? (itemData[getCsv('tav')] || '') : ''),
              unit: globalState.userUnits.alcoholUnit,
            },
    tavTemp: (!isEmpty && previousItemFormValues?.tavTemp)
            || {
              value: (getCsv('tavTemperature') ? (itemData[getCsv('tavTemperature')] || '') : ''),
              unit: globalState.userUnits.temperatureUnit,
            },
    volumeTemp: (!isEmpty && previousItemFormValues?.volumeTemp)
            || {
              value: (getCsv('volumeTemperature') ? (itemData[getCsv('volumeTemperature')] || '') : ''),
              unit: globalState.userUnits.temperatureUnit,
            },
    ...buildCustomOperatorFieldDefaults({
      itemData,
      columnMappings,
      customOperatorFields,
      previousItemFormValues,
    }),
  };
};
